import {
  CONFIG_FETCH,
  CONFIG_IS_FETCING,
} from 'constants/config'

export default function configReducer(state={},action){
  switch (action.type) {
    case CONFIG_FETCH:
        return {
          ...state,
          ...action.payload,
        }
    case CONFIG_IS_FETCING:
      return {
        ...state,
        isFetching:action.payload,
      }
    default:
        return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/config.js